module.exports = __webpack_public_path__ + "img/wb4@2x.c5f64c66.png";